import Link from 'next/link';
import { ChevronRight } from 'lucide-react';

export default function BlogBreadcrumbs({ items, className = '' }) {
    if (!items || items.length === 0) return null;

    return (
        <nav aria-label="Breadcrumb" className="mb-6">
            <ol className={`flex items-center space-x-2 text-sm text-gray-500 ${className}`}>
                <li>
                    <Link href="/blog" className="hover:text-brand-600 transition-colors">
                        Blog
                    </Link>
                </li>
                {items.map((item, index) => (
                    <li key={index} className="flex items-center space-x-2">
                        <ChevronRight className="w-4 h-4 text-gray-400" />
                        {item.href ? (
                            <Link href={item.href} className="hover:text-brand-600 transition-colors font-medium text-gray-700">
                                {item.label}
                            </Link>
                        ) : (
                            <span className="text-gray-900 border-b border-transparent font-medium line-clamp-1 max-w-[200px] sm:max-w-none" title={item.label}>
                                {item.label}
                            </span>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
}
